module.exports = __webpack_public_path__ + "static/media/haricots.beb52a12.svg";